module.exports = __webpack_public_path__ + "img/big-rank-cup.9bac55ed.png";